import { render, staticRenderFns } from "./ComponentAnniversary.vue?vue&type=template&id=3bd5a770&scoped=true"
import script from "./ComponentAnniversary.vue?vue&type=script&lang=js"
export * from "./ComponentAnniversary.vue?vue&type=script&lang=js"
import style0 from "./ComponentAnniversary.vue?vue&type=style&index=0&id=3bd5a770&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd5a770",
  null
  
)

export default component.exports